export default function () {
    if (jQuery('.js-hero--swiper').length > 0) {
        loadjs([menaObject.assets + '/js/swiper.min.js', menaObject.assets + '/css/swiper.css'], function () {
            const heroSwiper = new Swiper('.js-hero--swiper', {
                slidesPerView: 1,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: '.js-hero--swiper-pagination',
                    clickable: true,
                },
            });
        });
    }
}
